<template>
  <div>
    <table-card
      ref="datatable"
      module="VehicleList"
      :headers="headers"
      :actions="actions"
    >
      <template v-slot:action>
        <vs-button
          color="primary"
          type="gradient"
          class="mb-4 md:mb-0"
          @click="add"
          >Add New Data</vs-button
        >
      </template>
    </table-card>

    <vs-popup
      classContent="popup-example"
      :title="popupTitle"
      :active.sync="showPopup"
    >
      <template>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-2/2 w-full">
            <label class="vs-input--label">Brand</label>
            <v-select
              :clearable="false"
              :options="list_brand"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="input.veh_brand"
              placeholder="-- Select Brand --"
            />
          </div>
          <div class="vx-col sm:w-2/2 w-full">
            <label class="vs-input--label">Type</label>
            <v-select
              :clearable="false"
              :options="list_type"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="input.veh_type"
              placeholder="-- Select Type --"
            />
          </div>
          <div class="vx-col sm:w-2/2 w-full">
            <vs-input label="Name" class="w-full" v-model="input.name" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full ml-auto">
            <vs-button
              :disabled="isSubmit"
              id="submitBtn"
              class="mr-3 mb-2 vs-con-loading__container"
              @click="submit"
              >Submit</vs-button
            >
            <vs-button
              :disabled="isSubmit"
              v-show="action === 'store'"
              color="warning"
              type="border"
              @click="reset"
              class="mb-2"
              >Reset</vs-button
            >
          </div>
        </div>
      </template>
    </vs-popup>
  </div>
</template>

<script>
import TableCard from '@/components/TableCard'
import vSelect from 'vue-select'

export default {
  components: {
    TableCard,
    vSelect
  },

  data() {
    return {
      showPopup: false,
      popupTitle: '',
      action: '',
      isSubmit: false,
      input: {
        id: null,
        name: null,
        veh_brand: null,
        veh_type: null
      },
      list_brand: [],
      list_type: []
    }
  },

  computed: {
    headers() {
      return [
        [
          { label: 'Brand Name', value: 'brand_name' },
          { label: 'Type', value: 'type' },
          { label: 'Vehicle Name', value: 'name' }
        ]
      ]
    },
    actions() {
      return [
        {
          name: 'Edit',
          action: this.edit,
          icon: 'icon-edit',
          color: 'success'
        },
        {
          name: 'Delete',
          action: this.del,
          icon: 'icon-trash',
          color: 'danger'
        }
      ]
    }
  },
  watch: {},
  created() {},
  mounted() {},

  methods: {
    initTable() {
      this.$refs.datatable.initTable()
    },

    reset() {
      Object.keys(this.input).map((item) => {
        this.input[item] = null
      })
    },

    add() {
      if (this.action === 'update') this.reset()
      this.action = 'store'
      this.popupTitle = 'Add Vehicle List'
      this.showPopup = true

      this.listBrand('')
      this.listType('')
    },

    async listBrand(id_brand = '') {
      await this.$store.dispatch('VehicleList/list_brand').then((data) => {
        this.list_brand = data

        if (id_brand) {
          this.input.veh_brand = this.list_brand.find((item) => {
            return item.value === id_brand
          })
        }
      })
    },

    async listType(id_type = '') {
      await this.$store.dispatch('VehicleList/list_type').then((data) => {
        this.list_type = data

        if (id_type) {
          this.input.veh_type = this.list_type.find((item) => {
            return item.value === id_type
          })
        }
      })
    },

    async edit(id) {
      this.input.id = id
      this.action = 'update'
      this.popupTitle = 'Edit Vehicle List'

      await this.$store.dispatch('VehicleList/detail', id).then((data) => {
        this.input.name = data.name

        this.listBrand(data.veh_brand)
        this.listType(data.veh_type)
      })
      this.showPopup = true
    },

    async submit() {
      this.isSubmit = true
      this.loadingStart('#submitBtn', 'primary')
      const { status, message } = await this.$store.dispatch(
        `VehicleList/${this.action}`,
        {
          id: this.input.id,
          name: this.input.name,
          brand: this.input.veh_brand ? this.input.veh_brand.value : '',
          type: this.input.veh_type ? this.input.veh_type.value : ''
        }
      )
      this.isSubmit = false
      this.loadingStop('#submitBtn')
      if (status) {
        this.showNotify(message)
        this.initTable()
        this.reset()
        this.showPopup = false
      }
    },

    del(id) {
      this.input.id = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete Vehicle List`,
        text: 'Are you sure want to Delete this Vehicle List ?',
        accept: this.confirmDelete
      })
    },

    async confirmDelete() {
      const { status, message } = await this.$store.dispatch(
        'VehicleList/delete',
        this.input.id
      )
      if (status) {
        this.showNotify(message)
        this.initTable()
      }
    },

    loadingStart(el, color = 'success') {
      this.$vs.loading({
        background: color,
        color: '#fff',
        container: el,
        scale: 0.45
      })
    },

    loadingStop(el) {
      this.$vs.loading.close(`${el} > .con-vs-loading`)
    },

    showNotify(msg, type = 'success') {
      this.$vs.notify({
        title: 'Thank You',
        text: msg,
        color: type,
        position: 'top-right'
      })
    }
  }
}
</script>
